import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DynamicResourceService {

  private readonly baseUrl = '/resource-files';

  constructor(private readonly _httpClient: HttpClient) { }

  public findById(id: string, frontOfficeCall: boolean = false): Observable<string> {
    const options: {
      headers?: HttpHeaders | {
        [header: string]: string | string[];
      };
      responseType?: 'json';
    } = {
      responseType: 'text' as 'json'
    };

    if (frontOfficeCall) {
      options.headers = new HttpHeaders().append('Frontend-Request', 'true');
    }

    return this._httpClient.get<string>(`${this.baseUrl}/${id}`, options);
  }
}
